import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=141e7efc&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=ts"
export * from "./AppMenu.vue?vue&type=script&lang=ts"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=141e7efc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141e7efc",
  null
  
)

export default component.exports